import React, { Component, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export const CbCsoRegister = ({ containerObject, templateName, contentId, dataZone }) => {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [confirmPwd, setConfirmPwd] = useState('');
    const [isRevealConfirmPwd, setIsRevealConfirmPwd] = useState(false);
    const [tAndC, setTandC] = useState("false");
    const [optIn, setOptIn] = useState("true");
    const [registerError, setRegisterError] = useState("");
    const [token, setToken] = useState();
    const [redirectUrl, setRedirectUrl] = useState();
    const [domain, setDomain] = useState();
    useEffect(() => {
        setDomain(containerObject && containerObject.csoLogoImageUrl)
    }, [])
    const handleOptIn = () => {
        if (optIn == "true") {
            setOptIn("false")
        } else {
            setOptIn("true")
        }
    }

    const handleCallBack = (token) => {
        document.getElementById("sso-redirect").click();
    }
    const handleClearErrorMessages = ()=>{
        var errorFields = ['firstName', 'lastName', 'email', 'confirmPassword', 'password', 'tAndC', 'optIn'];
        errorFields.forEach((fieldName)=>{
            if(document.getElementById(fieldName.concat("_error"))){
                document.getElementById(fieldName.concat("_error")).innerHTML = '';
            }
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        formValue["tAndC"] = tAndC
        formValue["optIn"] = optIn
        handleClearErrorMessages();
        document.getElementById("sso-reg-error").classList.remove("d-block")
        document.getElementById("sso-reg-error").classList.add("d-none")
        document.getElementById("firstName_error").classList.remove("d-block");
        document.getElementById("firstName_error").classList.add("d-none");
        document.getElementById("cso-firstName").classList.remove("form-error");
        document.getElementById("lastName_error").classList.remove("d-block");
        document.getElementById("lastName_error").classList.add("d-none");
        document.getElementById("cso-lastName").classList.remove("form-error");
        document.getElementById("email_error").classList.remove("d-block");
        document.getElementById("email_error").classList.add("d-none");
        document.getElementById("cso-email").classList.remove("form-error");
        document.getElementById("password_error").classList.remove("d-block");
        document.getElementById("password_error").classList.add("d-none");
        document.getElementById("cso-password").classList.remove("form-error");
        document.getElementById("confirmPassword_error").classList.remove("d-block");
        document.getElementById("confirmPassword_error").classList.add("d-none");
        document.getElementById("cso-confirmPassword").classList.remove("form-error");
        document.getElementById("tAndC_error").classList.remove("d-block");
        document.getElementById("tAndC_error").classList.add("d-none");
        document.getElementById("optIn_error").classList.remove("d-block");
        document.getElementById("optIn_error").classList.add("d-none");
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {

                if (res.result === "success") {
                    console.log("successsss", "cso-reg-success")
                    const response = res.response && res.response.response;
                    const token = response && response.token
                    setToken(token);
                    var searchParam = window.location.search
                    const params = new URLSearchParams(searchParam);
                    var gotoUrl = params.get('goto')
                    console.log("goto", gotoUrl)
                    setRedirectUrl(gotoUrl ? gotoUrl : "")
                    if (gotoUrl) {
                        handleCallBack(token);
                    }
                } else {
                    var responseObj = JSON.parse(res.response)
                    handleRegistrationMessage(responseObj.errorMessage)
                }
            })
    }
    function handleRegistrationMessage(errorList) {
        console.log("errorList", errorList)
        document.getElementById("sso-reg-error").classList.remove("d-none");
        document.getElementById("sso-reg-error").classList.add("d-block");
        errorList && errorList.map((item, index) => {

            if (item.key != "tAndC" && item.key != "optIn") {
                document.getElementById("cso-".concat(item.key)).classList.add("form-error")
            }
            if (item.message != "hidden") {
                var html = document.getElementById(item.key.concat("_error")).innerHTML
                if (html) {
                    document.getElementById(item.key.concat("_error")).innerHTML = html + "</br>" + item.message;
                } else {
                    document.getElementById(item.key.concat("_error")).innerHTML = item.message;
                }
                document.getElementById(item.key.concat("_error")).classList.remove("d-none");
                document.getElementById(item.key.concat("_error")).classList.add("d-block");
            }
        });
    }
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`}>
            <div class="row justify-content-center cso-pages mx-1 px-md-2">
                <div class="row">
                    <div class="col-md-12">
                        <a href={domain} class="c-cso-logo">
                            <img src="/images/cso-logo.jpg" alt="Carolina Science Online" />
                        </a>
                    </div>
                    <hr />
                </div>
                <form method="post" action="SSO-register" id="registerSSO" className='sso-register' onSubmit={handleSubmit}>
                    <div class="row">
                        <div class="col-md-12">
                            <h1 className="c-account-list-heading mb-2">Create New Online Account</h1>
                            <div className="alert alert-danger d-none" role="alert" id="sso-reg-error">
                                <div id='firstName_error' className='d-none text-dark'></div>
                                <div id='lastName_error' className='d-none text-dark'></div>
                                <div id='email_error' className='d-none text-dark'></div>
                                <div id='confirmPassword_error' className='d-none text-dark'></div>
                                <div id='password_error' className='d-none text-dark'></div>
                                <div id='tAndC_error' className='d-none text-dark'></div>
                                <div id='optIn_error' className='d-none text-dark'></div>
                            </div>
                            <div class="mb-3 row">
                                <label for="staticEmail" className="col-sm-3 col-form-label fw-bold">Name: *</label>
                                <div class="col-sm-3 mb-3 mb-md-0">
                                    <input maxlength="19" name="firstName" id="cso-firstName" placeholder="First Name" type="text" className="form-control" />

                                </div>
                                <div class="col-sm-3 mb-3 mb-md-0">
                                    <input maxlength="19" name="lastName" id="cso-lastName" placeholder="Last Name" type="text" className="form-control" />
                                </div>
                            </div>
                            <hr />
                            <div class="mb-3 row">
                                <label for="staticEmail" className="col-sm-3 col-form-label fw-bold">Email: *</label>
                                <div class="col-sm-6">
                                    <input maxlength="256" name="email" id="cso-email" type="text" className="form-control mb-4" />
                                    <div class="form-check">
                                        <input name="optIn" id="cso-optIn" defaultChecked onClick={handleOptIn} type="checkbox" className="form-check-input" />
                                        <label className="form-check-label" for="flexCheckChecked">
                                            Yes, sign me up for relevant tips and how tos.
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="mb-3 row my-2" style={{ position: 'relative' }}>
                                <label for="inputPassword" className="col-sm-3 col-form-label fw-bold">New Password: *</label>
                                <div class="col-sm-3 position-relative">
                                    <input name="password" id="cso-password" type={isRevealPwd ? "text" : "password"} className="form-control" value={pwd} onChange={e => setPwd(e.target.value)} />
                                    <Link class="cso-password-show" style={{ position: 'absolute' }} id="show-password" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                        {isRevealPwd ? 'HIDE' : 'SHOW'}
                                    </Link>
                                </div>
                                <div class="col-sm-6">
                                    <p class="m-0">
                                        Passwords must be at least 6 characters long.
                                    </p>
                                </div>
                            </div>
                            <div class="mb-3 row my-2">
                                <label for="inputPassword" className="col-sm-3 col-form-label fw-bold">Confirm New Password: *</label>
                                <div class="col-sm-3 position-relative">
                                    <input name="confirmPassword" id="cso-confirmPassword" type={isRevealConfirmPwd ? "text" : "password"} className="form-control" value={confirmPwd} onChange={e => setConfirmPwd(e.target.value)} />
                                    <Link class="cso-password-show" style={{ position: 'absolute' }} id="show-password" onClick={() => setIsRevealConfirmPwd(prevState => !prevState)}>
                                        {isRevealConfirmPwd ? 'HIDE' : 'SHOW'}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-12 col-md-12 text-end">
                            <button name="registerSSO" type="submit" className="btn btn-primary btn-block">Submit</button>
                        </div>
                    </div>
                </form>
                <form method="post" className="d-none" action={redirectUrl}>
                    <input type="hidden" id="createdToken" name="createdToken" value={token} />
                    <input type="submit" id="sso-redirect" />
                </form>
            </div>
        </div>
    )
}
